import { render, staticRenderFns } from "./LmPagination.vue?vue&type=template&id=00160538&scoped=true&"
import script from "./LmPagination.vue?vue&type=script&lang=js&"
export * from "./LmPagination.vue?vue&type=script&lang=js&"
import style0 from "./LmPagination.vue?vue&type=style&index=0&id=00160538&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00160538",
  null
  
)

export default component.exports